module.exports = __webpack_public_path__ + "static/3-Buscando Luz-fb0e1c80cfb56578409a959709367303.jpg";